import * as Yup from 'yup';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';

import {
  Grid,
  DialogContent,
  Box,
  CircularProgress,
  Button
  //   useTheme
  //   useMediaQuery
} from '@mui/material';
import BrandDatePicker from 'src/components/FormInputs/BrandDatePicker';
import VehicleAutoComplete from 'src/components/FormInputs/BrandAutocomplete/VehiclesAutoComplete';
import DateTimeService from 'src/utils/DateTimeService';
import BooleanAutocomplete from 'src/components/FormInputs/BrandAutocomplete/BooleanAutoComplete';
import OrganizationAutocomplete from 'src/components/FormInputs/BrandAutocomplete/OrganizationAutoComplete';
import cleanObject from 'src/utils/cleanObject';
import toast from 'react-hot-toast';
import BrandAutocomplete from 'src/components/FormInputs/BrandAutocomplete';
import WardAutoComplete from 'src/components/FormInputs/BrandAutocomplete/WardAutoComplete';
import CircleAutoComplete from 'src/components/FormInputs/BrandAutocomplete/CircleAutoComplete';
import GroupAutocomplete from 'src/components/FormInputs/BrandAutocomplete/GroupAutocomplete';
import VehicleModelAutoComplete from 'src/components/FormInputs/BrandAutocomplete/VehicleModelAutoComplete';

function Filter({ filter, setFilter, loading }) {
  const { t } = useTranslation();

  //   const theme = useTheme();

  //   const mobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Formik
        initialValues={{
          ...filter
        }}
        validationSchema={Yup.object().shape({})}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
          try {
            const payload = {
              ...values,
              fromDate:
                values.fromDate &&
                DateTimeService.getMorningTime(values.fromDate).toISOString(),
              toDate:
                values.toDate &&
                DateTimeService.getMidnightTime(values.toDate).toISOString()
            };

            const cleanPayload = cleanObject(payload);

            if (!Object.values(cleanPayload).length) {
              toast.error('Atlest one filter is required');
              return;
            }
            console.log(values, payload);
            setFilter?.(payload);
            setStatus({ success: true });
            setSubmitting(false);
          } catch (err) {
            console.error(err);
            setErrors({ submit: err.message });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,

          handleSubmit,
          isSubmitting,
          setFieldValue,

          values
        }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent
              dividers
              sx={{
                p: 3
              }}
            >
              <Grid container spacing={3}>
                <OrganizationAutocomplete
                  value={values.organisation}
                  onChange={setFieldValue}
                />

                <BrandDatePicker
                  name="fromDate"
                  value={values.fromDate || null}
                  label="From Time"
                  onChange={setFieldValue}
                  md={12}
                />

                <BrandDatePicker
                  name="toDate"
                  value={values.toDate || null}
                  label="To Time"
                  onChange={setFieldValue}
                  md={12}
                />

                <GroupAutocomplete
                  name="group"
                  value={values.group}
                  onChange={setFieldValue}
                />
                <VehicleModelAutoComplete
                  value={values.model}
                  onChange={setFieldValue}
                  name="model"
                  multiple
                />
                <CircleAutoComplete
                  value={values.zone}
                  onChange={setFieldValue}
                  name="zone"
                  multiple
                />
                <WardAutoComplete
                  value={values.ward}
                  onChange={setFieldValue}
                  name="ward"
                  filter={values.zone ? { parentCircle: values.zone } : {}}
                  multiple
                />

                <VehicleAutoComplete
                  value={values.vehicleId}
                  onChange={setFieldValue}
                  name="vehicleId"
                  label="Vehicle"
                  multiple
                />
              </Grid>
            </DialogContent>

            <Box
              sx={{
                display: { xs: 'flex', sm: 'flex' },
                alignItems: 'center',
                justifyContent: 'space-between',
                p: 3
              }}
            >
              <Button
                fullWidth
                type="submit"
                startIcon={loading ? <CircularProgress size="1rem" /> : null}
                disabled={Boolean(errors.submit) || loading}
                variant="contained"
                size="large"
              >
                {t('Apply')}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </>
  );
}

export default Filter;
